import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../../incidentes.css";
import "bootstrap/dist/css/bootstrap.min.css";

const procesos = [
  {
    titulo: "Procesos POC",
    descripcion:
      "Una Prueba de Concepto (PoC) se puede " +
      "definir de manera sencilla como un proceso inicial y práctico " +
      "para evaluar la viabilidad y eficacia de una idea o tecnología " +
      "antes de comprometerse completamente con su implementación a gran escala.",
    acciones: [
      { label: "Procedimiento", to: "/procesos-internos/procesos-poc" },
      { label: "Matriz RACI", to: "/procesos-internos/procesos-poc-raci" },
    ],
  },
  {
    titulo: "Mantenimiento Preventivo",
    descripcion:
      "Después de completar una instalación, programar y documentar mantenimientos " +
      "preventivos es fundamental para garantizar la continuidad operativa y la " +
      "satisfacción del cliente. Un plan de revisiones periódicas permite detectar " +
      "posibles fallas antes de que ocurran y refuerza la confianza en nuestros servicios.",
    acciones: [
      { label: "Procedimiento", to: "/procesos-internos/mantenimiento-preventivo" },
    ],
  },
  {
    titulo: "Mantenimiento Correctivo",
    descripcion:
      "Cuando se presenta una incidencia o falla, es esencial contar con un protocolo " +
      "de mantenimiento correctivo que clasifique los casos por nivel de severidad " +
      "(crítico, alto, medio, bajo) y aplique los tiempos de respuesta y resolución " +
      "definidos en el SLA, garantizando la continuidad operativa del cliente.",
    acciones: [
      { label: "Procedimiento", to: "/procesos-internos/mantenimiento-correctivo" },
    ],
  },
];

const ProcesosInternos = () => {
  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Procesos y Actividades Ingeniería</h1>
        </div>
        <div className="orgproc-grid-3col">
          {procesos.map((proceso, index) => (
            <div className="orgproc-card" key={proceso.titulo}>
              <div className="orgproc-card-accent"></div>
              <div className="orgproc-card-body">
                <div className="orgproc-eyebrow">Proceso #{index + 1}</div>
                <div className="orgproc-card-title">{proceso.titulo}</div>
                <p className="orgproc-card-desc">{proceso.descripcion}</p>
                <div className="orgproc-card-actions">
                  {proceso.acciones.map((accion) => (
                    <Link className="orgproc-card-btn" to={accion.to} key={accion.to}>
                      {accion.label} →
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </>
  );
};

export default ProcesosInternos;

// https://app.diagrams.net/#G1HJo4V6_lXFNTb4mwHiA1kvTAdCy4tg1F
